export default class Form {
  constructor(element) {
    this.element = element;
    this.formElements = this.element.elements;
    this.init();
  }

  init() {
    this.element.setAttribute('novalidate', '');

    for (let i = 0; i < this.formElements.length; i++) {
      const input = this.formElements[i];

      if (input.required) {
        input.addEventListener('input', this.validateInput.bind(this));
      }
    }

    this.element.addEventListener('submit', this.onSubmit.bind(this));
  }

  /**
   * méthode appelée lorsque le bouton Confirmer est appuyer
   * @param {Event} event - valide le clic
   */
  onSubmit(event) {
    event.preventDefault();
    if (this.validate()) {
      console.log('success'); //envoi ajax du formulaire
      this.showConfirmation();
    } else {
      console.log('error'); //error
    }
  }
  /**
   * method description
   * @return {boolean} retourne le status de la validation
   */
  validate() {
    let isValid = true;
    for (let i = 0; i < this.formElements.length; i++) {
      const input = this.formElements[i];
      if (input.required && !this.validateInput(input)) {
        //si le champ est requis et qu'il n'est pas valide
        isValid = false;
      }
    }
    return isValid;
  }

  /**
   * valide chacun des champs
   * @param {Event} event - valide en direct
   */
  validateInput(event) {
    const input = event.currentTarget || event; // est ce que cette élément est le currentTarget. Si ça n'existe pas, n'est qu'un élément HTML

    if (input.validity.valid) {
      this.removeError(input);
    } else {
      this.addError(input);
    }

    return input.validity.valid;
  }

  addError(input) {
    const container =
      input.closest('[data-input-container]') || input.closest('.input'); //remonte tous les éléments pour trouver un match de la classe le plus proche possible
    container.classList.add('error');
  }

  removeError(input) {
    const container =
      input.closest('[data-input-container]') || input.closest('.input');
    container.classList.remove('error');
  }

  showConfirmation() {
    this.element.classList.add('is-sent');
  }
}
